// Table configuration
export const TABLE_HEADING = {
    column: [
        'Greetly Voucher ID',
        'Voucher ID',
        'voucherTheme',
        'Amount',
        'Created Date',
        'Store' + ' & ' + 'Location',
        'TopUp Status',
        'TopUp Date',
        'Hand Over Status',
    ],
};

// Filter configuration
export const TAB_STATUS_ITEMS = [
    { key: 'ALL', label: 'All' },
    { key: 'ACTIVE', label: 'Active' },
    { key: 'INACTIVE', label: 'Inactive' },
    { key: 'REDEEMED', label: 'Redeemed' },
];

export const DEFAULT_STATUS_KEY = 'ALL';

// Search configuration
export const SEARCH_DROPDOWN = [
    { key: 'GREETLY_ID', label: 'Greetly Voucher ID' },
    { key: 'VOUCHER_ID', label: 'Voucher ID' },
    { key: 'THEME_NAME', label: 'Theme Name' },
    { key: 'BATCH_ID', label: 'Batch ID' },
    { key: 'STORE', label: 'Store' }
];

export const SUB_SEARCH_DROPDOWN = [
    { key: 'LOCATION', label: 'Location' },
];

export const DEFAULT_SEARCH_PLACEHOLDER = 'Greetly Voucher ID';
export const DEFAULT_SEARCH_KEY = 'GREETLY_ID';
export const SEARCH_KEY_GREETLY_ID = 'GREETLY_ID';
export const SEARCH_KEY_VOUCHER_ID = 'VOUCHER_ID';
export const SEARCH_KEY_THEME_NAME = 'THEME_NAME';
export const SEARCH_KEY_BATCH_ID = 'BATCH_ID';
export const SEARCH_KEY_STORE = 'STORE';

export const DEFAULT_SUB_SEARCH_PLACEHOLDER = 'Location';
export const DEFAULT_SUB_SEARCH_KEY = 'LOCATION';
export const SUB_SEARCH_KEY_LOCATION = 'LOCATION';


// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SORT_BY = 'printDate';
export const DEFAULT_ORDER = 'asc';

// ZPL Printer configuration
export const ZPL_TEMPLATE = `^XA
^MD22
^PW799
^LL799
^CI28

# ----- LEFT QR (same X as your 3-QR layout) -----
^FO38,6^BQN,2,6^FDQA,https://thyaga.lk/greetly-topup/{greetlyId}^FS
^FO70,220^A0N,28,28^FD{greetlyId}^FS

# ----- RIGHT QR (use the 3-QR middle position: 302px) -----
^FO302,6^BQN,2,6^FDQA,https://thyaga.lk/checkbalance/{voucherId}^FS
^FO334,220^A0N,28,28^FD{voucherId}^FS

^XZ`;

export const THYAGA_GREETLY_TOPUP_URL = 'https://thyaga.lk/greetly-topup';
export const THYAGA_CHECK_BALANCE_URL = 'https://thyaga.lk/checkbalance';

// Initial state
export const INITIAL_STATE = {
    // Table configuration
    tableHeading: {
        column: TABLE_HEADING.column,
    },

    // Filter configuration
    tabItems: {
        status: TAB_STATUS_ITEMS,
    },
    statusKey: DEFAULT_STATUS_KEY,

    // Search configuration
    searchDropDown: SEARCH_DROPDOWN,
    subSearchDropDown: SUB_SEARCH_DROPDOWN,
    searchPlaceholder: DEFAULT_SEARCH_PLACEHOLDER,
    searchId: '',
    searchKey: DEFAULT_SEARCH_KEY,
    subSearchPlaceholder: DEFAULT_SUB_SEARCH_PLACEHOLDER,
    subSearchKey: DEFAULT_SUB_SEARCH_KEY,
    isClearable: false,
    isSearchApiCalled: false,

    // Loading states
    loading: false,
    csvLoading: false,

    // Data
    voucherData: [],
    currentPage: 0,
    totalPages: 0,
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    sortBy: DEFAULT_SORT_BY,
    order: DEFAULT_ORDER,

    // Error states
    fetchError: '',
    notFoundMessage: null,

    // Date filter states
    startDate: null,
    endDate: null,
    isFilterApiCalled: false,

    // Selection states
    selectAll: false,
    checkedRows: [],
    labelsToPrint: [],

    // Drawer and details states
    showVoucherDrawer: false,
    drawerData: null,
    voucherId: null,

    // Transaction states
    showTransactions: false,
    transactionDetails: [],
    transactionLoading: false,
    transactionError: '',
    selectedTransaction: null,
    isVoucherCreated: true,
    isVoucherTopup: false,
    isHandedOver: false,
};

// UI text constants
export const PRINT_QR_CODES_TEXT = 'Print QR Codes';
export const PRINT_WITH_ZEBRA_TEXT = 'Print with Zebra';
export const FILTER_BY_STATUS_TEXT = 'Filter by status';
export const PAGE_HEADER_TEXT = 'Greetly Vouchers';
export const CHECKBOX_INPUT_MAX_LENGTH = 10;

// Error messages
export const NO_VOUCHERS_FOUND_MESSAGE = 'No vouchers found';
export const NO_VOUCHERS_FOUND_FOR_STATUS_MESSAGE = 'No vouchers found for status';
export const NO_VOUCHERS_FOUND_FOR_GREETLY_ID_MESSAGE = 'No vouchers found for Greetly ID';
export const NO_VOUCHERS_FOUND_FOR_VOUCHER_ID_MESSAGE = 'No vouchers found for Voucher ID';
export const NO_VOUCHERS_FOUND_BETWEEN_DATES_MESSAGE = 'No vouchers found between entered dates';
export const NO_VOUCHERS_FOUND_FOR_LOCATION_MESSAGE = 'No vouchers found for Location'; 
export const FETCH_VOUCHERS_ERROR_MESSAGE = 'Error fetching greetly vouchers. Please try again later.';
